var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6196 0.98957C10.1296 0.49957 9.33957 0.49957 8.84957 0.98957L0.53957 9.29957C0.14957 9.68957 0.14957 10.3196 0.53957 10.7096L8.84957 19.0196C9.33957 19.5096 10.1296 19.5096 10.6196 19.0196C11.1096 18.5296 11.1096 17.7396 10.6196 17.2496L3.37957 9.99957L10.6296 2.74957C11.1096 2.26957 11.1096 1.46957 10.6196 0.98957Z",
    fill: "#003893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowLg);
export default __webpack_public_path__ + "static/media/LeftArrowLg.d444c60a110e284823618f8f58362a61.svg";
export { ForwardRef as ReactComponent };